import React, { useState } from 'react';
import { Button, Flex } from 'antd';
import { useEffect } from 'react';
import gett from '../ApiSeervice';
import { Link } from 'react-router-dom';


const PanelOptions = () => {

    const [projects, setProjects] = useState([])

    async function getProjects() {
        const abc = await gett();
        console.log(abc)
        setProjects(abc);
    }

    useEffect(() => {
        getProjects();

    }
        , [])

    return (
        <div>
                        <h1  style={{marginLeft:"2vw"}}>Projeler </h1>
            <div style={{ display: "flex", width: "100vw", height: "10vh", alignItems: "center" }}>
                <Link style={{ marginLeft: "10vw" }} to={`/add-project`}>Proje Ekle</Link>
            </div>

            <div className="themesflat-project style-2 isotope-project has-margin mg15 data-effect clearfix" style={{ padding: "0 10vw 0 10vw " }}>
                {projects.map(data => (
                    <div className={"project-item architecture building construction"} key={data.id}>
                        <div className="inner">
                            <div className="thumb data-effect-item has-effect-icon w40 offset-v-19 offset-h-49">
                                <img style={{ height: "100%" ,height: "22vh",
                                        width: "100%",
                                        objectFit: "cover",}} src={data.photos[0].path} alt="altimage" />
                                <div className="elm-link">
                                    {/* <Link to="#" className="icon-1 icon-search" /> */}
                                    {/* <Link onClick={() => history.push("/project-detail")} className="icon-1" /> */}
                                </div>
                                <div className="overlay-effect bg-color-3" />
                            </div>
                            <div className="text-wrap">
                                <h5 className="heading">
                                    <Link to={`/panel-project-detail/${data.id}`}  >{data.title}</Link>

                                </h5>
                                <div className="elm-meta">
                                    {/* <span>
                                <Link to="#">{data.name01}</Link>
                            </span>
                            <span>
                                <Link to="#">{data.name02}</Link>  //filtreleme için kullanılıyor
                            </span> */}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );

};
export default PanelOptions;